import Axios from './axios'

// 封装User类型的接口方法
export class CooperateService {
  static userList(params: any) {
    return Axios('/space/ppt/user_list/', {
      method: 'get',
      params
    })
  }
  static memberList(params: any) {
    return Axios('/space/ppt/member_list/', {
      method: 'get',
      params
    })
  }
  static addMember(data: any) {
    return Axios('/space/ppt/add_member/', {
      method: 'post',
      data:data
    })
  }
  static updateRole(data: any) {
    return Axios('/space/ppt/update_role/', {
      method: 'post',
      data:data
    })
  }
  static updateShare(data: any) {
    return Axios('/space/ppt/update_share/', {
      method: 'post',
      data:data
    })
  }
  static shareInfo(params: any) {
    return Axios('/space/ppt/share_detail/', {
      method: 'get',
      params
    })
  }
  static share(id:any,params: any) {
    return Axios('/space/ppt/share/' + id, {
      method: 'post',
      data:params
    })
  }
  static updateInvite(data: any) {
    return Axios('/space/ppt/update_invite/', {
      method: 'post',
      data:data
    })
  }
  static inviteInfo(params: any) {
    return Axios('/space/ppt/invite_detail/', {
      method: 'get',
      params
    })
  }
  static invite(id:any,params: any) {
    return Axios('/space/ppt/invite/' + id, {
      method: 'post',
      data:params
    })
  }
  static editList(params: any) {
    return Axios('/space/ppt/content_editing_list/', {
      method: 'get',
      params
    })
  }
  static teamList(params: any) {
    return Axios('/space/ppt/team_member_list/', {
      method: 'get',
      params
    })
  }
  static recentlyMemberList(params: any) {
    return Axios('/space/ppt/recently_member_list/', {
      method: 'get',
      params
    })
  }
  static removeMember(data: any) {
    return Axios('/space/ppt/remove_member/', {
      method: 'post',
      data:data
    })
  }
  static contentDetail(id: any) {
    return Axios('/space/ppt/content_detail/share/' + id, {
      method: 'post',
    })
  }
  static contentInviteDetail(id: any) {
    return Axios('/space/ppt/content_detail/invite/' + id, {
      method: 'post',
    })
  }

}